var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CarouselCard,{attrs:{"id":_vm.category.taxonomyID,"title":_vm.category.name,"href":_vm.category.url,"target":_vm.category.linkTarget || undefined,"image-urls":_setup.imageUrls}})
}
var staticRenderFns = []

export { render, staticRenderFns }